import React from 'react'
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button , Input , FormGroup, Label} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";

import * as actions from  '../../../actions/factura';
import {api} from '../../../actions/_request';

import _ from "lodash";
import Select from 'react-select';

import moment from 'moment';

import Menu from '../menu.js';
import ModalTablas from '../../../components/catalogos/modal_tablas.js'
import FacturaModal from './invoiceProductos.js'

import IconEdit from 'react-icons/lib/md/edit'
import IconList from 'react-icons/lib/fa/list-alt'
import IconHistorico from 'react-icons/lib/fa/archive'
import IconPlus from 'react-icons/lib/fa/plus'
import FAchevronleft from 'react-icons/lib/fa/chevron-left';
import Refresh from 'react-icons/lib/fa/refresh';


// react-icons/lib/fa/refresh

import swal from 'sweetalert2';
const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String((row[id]+'').toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };


class InvoiceModuleForm extends React.Component{
	constructor(props){
		super(props)

		this.state = {
			factura : {
				factura_consecutivo : '',
				concepto : '',
				fecha : moment().format('Y-MM-DD'),
				tc : '',
				moneda: 'MXN',
				cliente_id : '',
				vendedor_id : '',
				almacen_codigo : '',
				comision : '',
				facturar_a : '',
				direccion : '',
				no_guia : '',
				lab_id : '',
				lab_codigo : '',
				notasHeader : '',
				plazo_p : '',
				modalProducto : false,
				tipo_doc : '1',
        importe : 0,
        descuentos : 0,
        subtotal : 0,
        ieps : 0,
        total : 0,
        impuestos : 0,
        impuesto1_prod : 0,
        impuesto2_prod : 0,
        saldo : 0,
        credito_disponible : 0,
        fecha_timbrado : moment().format('Y-MM-DD'),

			},
			productos : [],
      tickets: [],
			folios : [],
			modal : false,
      action:'save',
      indiceproducto : null,
      prospectoid : null,
      producto_renglon:[],
		}

		this.handleInputChange = this.handleInputChange.bind(this); 
		this.toggle_modal= this.toggle_modal.bind(this);   
        this.retorno= this.retorno.bind(this);  
        this.ChangeCode= this.ChangeCode.bind(this);
        this.handleClose= this.handleClose.bind(this);

        this.handleRadioChange = this.handleRadioChange.bind(this);

        this.toggleProducto = this.toggleProducto.bind(this);
        this.retornoProducto = this.retornoProducto.bind(this);

        this.handleSelectChange= this.handleSelectChange.bind(this);
        this.delete = this.delete.bind(this);
        this.submit = this.submit.bind(this);
        this.actualizar_tc = this.actualizar_tc.bind(this);
        this.delete_ticket = this.delete_ticket.bind(this);
        this.validacion_consecutivo = this.validacion_consecutivo.bind(this);

	}
 actualizar_tc(){
  let {factura} = this.state;
  let self = this;
  api().get('/tipo_cambio_venta')
        .then(function(response)
        {             
          // console.log(response)     
            if(response.status === 200)
            { 
              
              factura.tc = parseFloat(response.data.venta);
               self.setState({
                  factura : factura,
               })
            }

        });
 }

  validacion_consecutivo(){
  let {factura} = this.state;
  let self = this;
  api().get('/validar_consecutivo/'+factura.factura_consecutivo)
        .then(function(response)
        {             
          // console.log(response)     
            if(response.status === 200)
            { 
              
              let validacion = response.data.validacion;
              // console.log('validacion-->',validacion)
              if(validacion==false){
                if(response.data.encontrado[0].id!=factura.id)
                swal("Oops..", "Ya Existe La Referencia");
              }
               
            }
              

        });
 }
	
	componentDidMount() {
		let self = this;
		let {factura} = self.state;
    const {params} = this.props.match;

		


      api().get('/formulario_factura')
      .then(function(response)
      {
        if(response.status === 200)
        {
          factura.almacen_codigo=response.data.almacen.codigo;
          factura.almacen_nombre=response.data.almacen.nombre;
          factura.almacen_id=response.data.almacen.id;
          factura.tc=response.data.cambio;

          self.setState({
            formas : response.data.formas,
            metodos : response.data.metodos,
            usos : response.data.usos,
            factura:factura,
          });

          if(params.id){
          api().get('/searchInvoice/'+params.id).then((response) => {
           // console.log('factura---->',response.data);
            self.setState({
              factura: response.data.factura,
              productos:response.data.productos,
              action:'update',
            });
          });
        }



          
        }
      });			
    }

    handleSelectChange(select, name,tipo=0) {
    	let {factura} = this.state;
      let value=null;
        if(tipo==0){
           value = select === null ? null : select.target.value;
        }else{
           value = select === null ? null : select.value;
        }
        
        

		factura[name] = value;
    

        this.setState({factura : factura});

    }


	handleInputChange(event) {
        let {factura} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        factura[name] = value;
     
        this.setState({
            factura : factura
        });
    }
    handleClose (event) {
     
        let {producto} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        
        let campo="";
        let tabla=""

        
         switch (name) {
            case "cliente_id":                  
                campo = "cliente_id";
                tabla="/busqueda_cliente/"+this.state.factura.cliente_id;
                break;
            case "vendedor_id":                  
	            campo = "vendedor_id";
	            tabla="/busqueda_usuario/"+this.state.factura.vendedor_id;
	            break;   
	        case "almacen_codigo":                  
	            campo = "almacen_codigo";
	            tabla="/busqueda_almacen/"+this.state.factura.almacen_codigo;
	            break;
	        case "embarque_id":
	        	campo = "embarque_id";
	        	tabla = "/embarque/"+this.state.factura.embarque_id;
	        	break;
	       	case "lab_codigo":
	       		campo = "lab_id";
	       		tabla = "/lab/"+this.state.factura.lab_codigo;
	       		break;
	       	case "term_pago":
	       		campo = "term_pago_nombre";
	       		tabla = "/terminos_pago/"+this.state.factura.term_pago;
	       		break;
        }
        let self =this;
        if(value!=""){
            api().get(`${tabla}`)
            .then(function(response)
            {             
            	// console.log(response)     
                if(response.status === 200)
                { 
                    let vaciar=0;
                     if(Object.keys(response.data).length > 0){
                        
                        let  retorno=response.data;
                        self.retorno(retorno,campo,vaciar,value);
                       
                       
                     }  else{
                         vaciar=1
                         swal("Oops..", "No Existe el Codigo");
                          self.retorno(response.data,campo,vaciar,value);
                     }        
                   
                }

            });
        }else{
            self.retorno([],campo,1,value); 
        }
   }

    ChangeCode(event) {
        let {inventarioFisico} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        if(target.type === 'checkbox'){
            value='0';
            if(target.checked)
                value='1';
        }
        inventarioFisico[name]=value;
        
            this.setState({
            	inventarioFisico :inventarioFisico
           });   
    }

    handleRadioChange(event) {
    	let {factura} = this.state;

    	factura['moneda']= event.target.value

		this.setState({
	    	factura : factura
	   	});
	}

    retorno(objeto,campo,vacio=0,valor=""){
       	// console.log('renglon---->',objeto);
        let {factura} = this.state;
        let self =this;
        let bandera=0;

        switch (campo) {
            case "cliente_id":
                  factura[campo] = objeto.item_id?objeto.item_id:objeto.value;
                  factura.cliente_nombre=objeto.label?objeto.label:objeto.nombre;
                  factura.facturar_a = objeto.rSocial;
                  factura.direccion = objeto.domicilio;
                  factura.rfc = objeto.rfc;
                  factura.ciudad = objeto.ciudad;
                  factura.term_pago = objeto.term_pago;
                  factura.term_pago_nombre = objeto.term_pago_nombre;
                  factura.vendedor_id = objeto.vendedor?objeto.vendedor.id:'';
                  factura.vendedor_nombre = objeto.vendedor?objeto.vendedor.name : '';
                  factura.comision = objeto.comision;
                  factura.codigo_comision = objeto.codigo_comision;
                  factura.plazo_p = objeto.plazo_credito;
                  factura.descuento = objeto.descuento;
                  factura.codigo_precio = objeto.codigo_precio;
                  factura.embarque_id = objeto.embarque_id;
                  factura.embarque_nombre = objeto.embarque_nombre;
                  factura.lab_id = objeto.lab_id;
                  factura.lab_nombre = objeto.lab_nombre;
                  factura.saldo_cliente = objeto.saldo;
                  factura.credito_disponible = objeto.credito_disponible;
                  factura.recidencia_fiscal = objeto.codigo_pais;
                  factura.registro_fiscal = objeto.registro_fiscal;
                  factura.uso_cfdi = objeto.uso_cfdi;
                  factura.formas_pago_codigo = objeto.forma_pago;
                  factura.metodo_pago_codigo = objeto.metodo_pago;
                  break;
            case "vendedor_id":
                  factura[campo] = objeto.value;
                  factura.vendedor_nombre=objeto.label?objeto.label:objeto.nombre;
                  break;
            case "almacen_codigo":
              factura.almacen_codigo = objeto.codigo;
            	factura.almacen_id = objeto.value;
            	factura.almacen_nombre = objeto.label?objeto.label:objeto.nombre;
            	break;
           	case "embarque_id":
           		factura.embarque_nombre = objeto.label?objeto.label:objeto.nombre;;
           		break;
           	case "lab_id":
           		factura.lab_nombre = objeto.label?objeto.label:objeto.nombre;
              factura.lab_id = objeto.item_id?objeto.item_id:objeto.value;
           		break;
           	case "term_pago_nombre":
           		factura[campo] = objeto.label?objeto.label:objeto.nombre;
           		break;
            case'factura_imp':
              self.importar_productos(0,objeto.productos);
              bandera=1;
              break;
            case'ticket_imp':
              self.importar_productos(1,objeto.productos);
              bandera=1;
              break;
        }  

       if(vacio==1){
        // console.log('vaciar')
        if(campo == 'cliente_id')
        	factura.cliente_id='';
        else if(campo == 'vendedor_id'){
        	factura.vendedor_id='';
        }
        else if(campo == 'almacen_codigo'){
        	factura.almacen_codigo = '';
        }
        
        //factura[campo] =0;

       }

       if(bandera==0){
        self.setState({
            factura : factura,           
            modal:false,         
        })
       }else{
        self.setState({     
            modal:false,         
        })
       }


         
    }
    

    toggle(){

    }

    delete(evt,index){
    	let {productos, factura} = this.state;   
      let renglon=productos[index];

      if( parseInt(renglon.ticket_id)>0){
          for (var i = productos.length - 1; i >= 0; i--) {
            if(parseInt(renglon.ticket_id)==parseInt(productos[i].ticket_id))
            productos.splice(i,1);
          }
      }  
      
    	this.calcular_totales(productos,factura);
    }

    delete_ticket(evt,renglon){
      console.log('delete ticket');
      console.log('ticket--->',renglon);

      let {productos, factura} = this.state;   
          for (var i = productos.length - 1; i >= 0; i--) {
            if(parseInt(renglon.id)==parseInt(productos[i].ticket_id))
            productos.splice(i,1);
          }
      
      
      this.calcular_totales(productos,factura);
    }

    toggleProducto(evt,item_id=null,indice=null,producto=[]){
    let {modalProducto} = this.state;

    this.setState({
      modalProducto : !modalProducto,
       indiceproducto : indice,
        prospectoid : item_id,
        producto_renglon:producto,
    })
  }

    toggle_modal(index=0,catalogo="",campo=""){  

        this.setState({
            modal : !this.state.modal,
            titulo:catalogo,
            tabla_modal:index,
            campo_modal:campo,         
        })
    }
    trunc (sVal, nDec = 0) {
      // var s = x.toString()
      // var l = s.length
      // var decimalLength = s.indexOf('.') + 1
      // var numStr = s.substr(0, decimalLength + posiciones)
      // return Number(numStr)


        var n = parseFloat(sVal); 
        var s = "0.00"; 
        if (!isNaN(n)){ 
         n = Math.round(n * Math.pow(10, nDec)) / Math.pow(10, nDec); 
         s = String(n); 
         s += (s.indexOf(".") == -1? ".": "") + String(Math.pow(10, nDec)).substr(1); 
         s = s.substr(0, s.indexOf(".") + nDec + 1); 
        } 
        return s; 
    }

    retornoProducto(obj){
    	let {productos} = this.state;

      let {factura} = this.state;

       var indiceproducto= this.state.indiceproducto;
       // console.log('producto---->',obj);
       // console.log('indice--->',indiceproducto)
      if(indiceproducto==null){
       productos.unshift(obj);
      }else{
        productos[indiceproducto]=obj;

      }
      this.calcular_totales(productos,factura);

     

  

     

    }
    calcular_totales(productos,factura){
      let importe=0;
      let descuentos=0;
      let subtotal=0;
      let ieps=0;
      let impuestos=0;
      let total=0;
      let tickets=[];
      let bandera=true;

      for (var i = productos.length - 1; i >= 0; i--) {
        bandera=true;
        importe+=parseFloat( productos[i].importe);
        descuentos+=parseFloat( productos[i].descuento);
        subtotal+=(parseFloat( productos[i].importe)-parseFloat( productos[i].descuento));
        impuestos+=(parseFloat( productos[i].impuesto1)+parseFloat( productos[i].impuesto2));
        ieps+=parseFloat( productos[i].ieps_venta);
        total+=parseFloat( productos[i].total);

        if(parseInt( productos[i].ticket_id)>0)
        {  
          for (var x = tickets.length - 1; x >= 0; x--) {

           if( parseInt( tickets[x].id) == parseInt( productos[i].ticket_id) )
           {
            bandera=false;
            break;
           }

          }
          if(bandera){
            tickets.push({
             id: productos[i].ticket_id,
             clave:  productos[i].clave_ticket,
            });
          }
        }
      }

      factura.importe = this.trunc(importe,2);
      factura.descuentos = this.trunc(descuentos,2);
      factura.subtotal = this.trunc(subtotal,2);
      factura.ieps = this.trunc(ieps,2);
      factura.impuestos = this.trunc(impuestos,2);
      factura.total = this.trunc(total,2);
      // console.log('lista tickets----->',tickets);
      this.setState({
            productos:productos,
            factura:factura, 
            tickets: tickets,        
        })
    }

    importar_productos(tipo,importacion){
      // console.log('productos a importar-->', importacion)
      let {productos} = this.state;
      let {factura} = this.state;
       for (var i = importacion.length - 1; i >= 0; i--) {
        if(tipo==0){
          //productos que vienen de una factura o cotizacion
          productos.unshift(importacion[i]);
        }else{
          let tem=importacion[i];
          let tempCantidad = parseFloat(tem.cantidad);
          let tempPrecio = parseFloat(tem.precio);
          let tempDescuento = parseFloat(tem.descuento_porc);
          let tempieps = parseFloat(tem.ieps_venta_porc);
          let tempImpto1 = parseFloat(tem.impuesto1_porc);
          let tempImpto2 = parseFloat(tem.impuesto2_porc);

          let tempImporte = tempCantidad * tempPrecio;

          let descuentoItem = (tempImporte * tempDescuento / 100);
          let subTotal = tempImporte - descuentoItem;

          let iepsItem = subTotal * tempieps / 100; 

          let subIeps = subTotal+ iepsItem;

          let tempimpuesto1 = subIeps * tempImpto1 / 100;
          let tempimpuesto2 = subIeps * tempImpto2 / 100;

          let tempImpuestos = tempimpuesto1 + tempimpuesto2;

          let tempTotal = subTotal + iepsItem + tempImpuestos;


          tem.importe = this.trunc(tempImporte,2);
          tem.descuento = this.trunc(descuentoItem,2);
          tem.subtotal = this.trunc(subTotal,2);
          tem.ieps_venta = this.trunc(iepsItem,2);
          tem.impuestos = this.trunc(tempImpuestos,2);
          tem.impuesto1 = this.trunc(tempimpuesto1,2);
          tem.impuesto2 = this.trunc(tempimpuesto2,2);
          tem.total = this.trunc(tempTotal,2);

          // console.log('importe--->',tempImporte);
          // console.log('subtotal --->',subTotal);
          // console.log('ieps --->',iepsItem);
          // console.log('impuestos ---> ',tempImpuestos);
          // console.log('producto --->',tem);

          productos.unshift(tem);


        }
      }
      this.calcular_totales(productos,factura);

    }

    submit(evt){

      let self = this;

      let{factura} = this.state;

      let{productos,action,tickets} = this.state;

      var newarray = [];



      factura.items = newarray;

      if(action=='save'){
        factura.saldo = factura.total;
        factura.saldo_impuesto = 0;
        factura.saldo_subtotal = factura.saldo;
        factura.importada = 1;
      }

      

      if(factura.tipo_doc == '1')
        factura.concepto = 'FACTURA';
      else
        factura.concepto = 'REMISION';
       

       api().get('/validar_consecutivo/'+factura.factura_consecutivo)
        .then(function(response)
        {             
          // console.log(response)     
            if(response.status === 200)
            { 
              
              let validacion = response.data.validacion;
              console.log('encontrado--->',response.data.encontrado[0])
              if(validacion==false&& response.data.encontrado[0].id!=factura.id){
                swal("Oops..", "Ya Existe La Referencia");
              }else{
                  if(action=='save'){

                    self.props.save_importacion(factura, (data) => {
                      self.props.alerta({
                        mensaje:"Factura Guardada Correctamente",
                        tipo:"success",
                        creacion:moment().format('Y-MM-DD H:m:s'),
                      });
                      self.props.history.push('/invoiceModule');
                    });

                  }else{

                    self.props.update_importacion(factura, (data) => {
                      self.props.alerta({
                        mensaje:"Factura Guardada Correctamente",
                        tipo:"success",
                        creacion:moment().format('Y-MM-DD H:m:s'),
                      });
                      self.props.history.push('/invoiceModule');
                    });

                  }
              }
               
            
            }
              

        });

      

      

    }

	render(){

		let {factura} = this.state;
		let {productos} = this.state;
    let {tickets} = this.state;
		let {folios} = this.state;
		let loading = false;
    // console.log(factura)
		return(
			<div className="view">
            	<Menu props={this.props}/>
                <div className="view-header">
                    <header className="title text-white">
                      <div className="row">
                        <div className="col">
                          <h1 className="h4 text-uppercase">Importacion de Facturaa </h1>
                        </div>
                      </div>
                    </header>
                </div>
           		<div className="view-content view-components">
                    <Card>
                    	<CardBlock>
                        <div className="row">
                          <div className="col-12 col-sm-6 col-md-4"> 
                              <div className="">
                                <label className="">Cliente: </label><br/>
                                <div style={{display : 'flex'}}>
                                  <input
                                    placeholder=""
                                    type="text"
                                    name="cliente_id"
                                    value={factura.cliente_id}
                                    onChange={ this.handleInputChange}
                                    onBlur={this.handleClose}
                                    className="input_factura"
                                  />
                                  <Button style={{height: '33px'}} onClick={ (button) => { this.toggle_modal(30,"Clientes","cliente_id") } } >...</Button>
                                  <p className="ml-1">{factura.cliente_nombre}</p>
                                </div>
                              </div>
                          </div>
                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form-group">
                              <label>Factura/Remision </label><br/>
                              {/*<select */}
                              <Input type="select" 
                                name="tipo_doc" 
                                id="exampleSelect" 
                                value={factura.tipo_doc} 
                                onChange={(e) => this.handleSelectChange(e,'tipo_doc')}
                                style={{width: '130px'}}
                              >
                                <option value={1}>Factura</option>
                                <option value={2}>Remision</option>
                              </Input>
                              {/*</select>*/}
                            </div>
                          </div>
                          <div className="col-12 col-sm-6 col-md-2">
                            <div className="form-group">
                              <label>Moneda </label><br/>
                              {/*<select value={factura.moneda} onChange={(e) => this.handleSelectChange(e,'moneda')}>*/}
                              <Input type="select" 
                                name="moneda" 
                                id="exampleSelect" 
                                value={factura.moneda} 
                                onChange={(e) => this.handleSelectChange(e,'moneda')}
                                style={{width: '130px'}}
                              >
                                <option value={'MXN'}>Peso (MXN)</option>
                                <option value={'USD'}>Dolar (USD)</option>
                              </Input>
                              {/*</select>   <div className="col text-right" >
                            
                                {' '}
                          </div>*/}
                            </div>
                          </div>
                          <div className="col-12 col-sm-6 col-md-2">
                            <div className="form-group">
                            <Button className="btn" onClick={ (button) => { this.props.history.push('/invoiceModule') } }  color="secondary"><FAchevronleft/> Atras</Button>
                          {' '}
                              <Button color="primary" className="mb-2" onClick={this.submit}>
                              {<IconList/>}&nbsp;Guardar
                            </Button>
                            </div>
                          </div>
                        </div>
                    		<div className="row mt-4">
                          <div className="col-8 div_titulo  ">
                            <h1><span>Datos Cliente</span></h1>
                            <div className="row">
                              <div className="col-6 ">
                                <div className="form-group">
                                  <label><b>Facturar a:</b> {factura.facturar_a}</label>
                                </div>
                              </div>
                              <div className="col-3 ">
                                <div className="form-group">
                                  <label><b>rfc: </b>{factura.rfc}</label>
                                </div>
                              </div>
                              <div className="col-3 ">
                                <div className="form-group">
                                  <label><b>Ciudad:</b> {factura.ciudad}</label>
                                </div>
                              </div>
                              <div className="col-3 ">
                                <div className="form-group">
                                  <label><b>Residencia F.:</b> {factura.recidencia_fiscal}</label>
                                </div>
                              </div>
                              <div className="col-3 ">
                                <div className="form-group">
                                  <label><b>Registro de I. Fiscal:</b> {factura.registro_fiscal}</label>
                                </div>
                              </div>
                              <div className="col-md-3 ">
                                <div className="form-group">
                                  <label><b>SALDO:</b> </label>
                                  <label className='ml-2'>{factura.saldo_cliente}</label>
                                </div>
                              </div>
                              <div className="col-md-3 ">
                                <div className="form-group">
                                  <label><b> Credito Dis.: </b></label>
                                  <label className='ml-2'>{factura.credito_disponible}</label>
                                </div>
                              </div>
                              <div className="col-12 ">
                                <div className="form-group">
                                  <label><b>Dirección:</b> {factura.direccion}</label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-4">
                            <div className="row">
                              <div className="col-12"> 
                                <div className="form-group">
                                    <label className="-block">Almacen:</label><br/>
                                    <input
                                      placeholder=""
                                      type="text"
                                      name="almacen_codigo"
                                      value={factura.almacen_codigo}
                                      onChange={ this.handleInputChange}
                                      onBlur={this.handleClose}
                                      className="input_factura"
                                    />
                                    <Button onClick={ (button) => { this.toggle_modal(25,"Almacenes","almacen_codigo") } } >...</Button>
                                    <label className="mt-2  ml-3">
                                      {factura.almacen_nombre}
                                    </label>
                                </div>
                              </div>
                            </div>
                          </div>

	                   		</div>
                        <div className="row mt-4">
                          <div className="col-12 div_titulo">
                            <h1><span>Datos Generales</span></h1>
                            <div className="row">
                              <div className="col-md-3">
                                <div className="form-group">
                                    <label>Fecha:</label>
                                    <Input
                                      required
                                      placeholder=""
                                      type="date"
                                      name="fecha_timbrado"
                                      value={factura.fecha_timbrado}
                                      onChange={this.handleInputChange}
                                    />
                                  </div>
                              </div>
                              <div className="col-md-3"> 
                                <div className="form-group">
                                  <label className>Referencia:</label>
                                  <input
                                      placeholder=""
                                      type="text"
                                      name="factura_consecutivo"
                                      value={factura.factura_consecutivo}
                                      onChange={this.handleInputChange}
                                      onBlur={this.validacion_consecutivo}
                                      className="form-control"
                                    />
                                </div>
                              </div>
                              
                            <div className="col-md-5"> 
                                <div className="form-group">
                                    <label className>UUID:</label>
                                    <input
                                      placeholder=""
                                      type="text"
                                      name="uuid"
                                      value={factura.uuid}
                                      onChange={this.handleInputChange}
                                      className="form-control"
                                    />
                                </div>
                            </div>
                            
                            <div className="col-md-2"> 
                                <div className="form-group">
                                    <label className>Total de la Factura:</label>
                                    <input
                                      placeholder=""
                                      type="number"
                                      name="total"
                                      value={factura.total}
                                      onChange={this.handleInputChange}
                                      className="form-control"
                                    />
                                </div>
                            </div>
                            
                            <div className="col-md-2"> 
                                <div className="form-group">
                                    <label className>Tipo de Cambio:</label>
                                    <input
                                      placeholder=""
                                      type="number"
                                      name="tc"
                                      value={factura.tc}
                                      onChange={this.handleInputChange}
                                      className="form-control"
                                    />
                                </div>
                            </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-4">
                          <div className="col-12 div_titulo">
                            <h1><span>Datos Fiscales</span></h1>
                            <div className="row">
                              <div className="col-md-3"> 
                                <div className="form-group">
                                  <label className>Forma de Pago:</label>
                                  <Select
                                    placeholder=""
                                    type="text"
                                    name="formas_pago_codigo"
                                    options={this.state.formas}
                                    value={factura.formas_pago_codigo || ""}
                                    onChange={ (select) => { this.handleSelectChange(select, 'formas_pago_codigo',1) } }
                                    clearable={false}
                                  />
                                </div>
                              </div>
                              <div className="col-md-3"> 
                                <div className="form-group">
                                    <label className>Metodo de Pago:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="metodo_pago_codigo"
                                        options={this.state.metodos}
                                        value={factura.metodo_pago_codigo || ""}
                                        onChange={ (select) => { this.handleSelectChange(select, 'metodo_pago_codigo',1) } }
                                        clearable={false}

                                    />
                                </div>
                            </div>
                            <div className="col-md-6"> 
                                <div className="form-group">
                                    <label className>Uso del CFDI:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="uso_cfdi"
                                        options={this.state.usos}
                                        value={factura.uso_cfdi || ""}
                                        onChange={ (select) => { this.handleSelectChange(select, 'uso_cfdi',1) } }
                                        clearable={false}

                                    />
                                </div>
                            </div>
                            </div>
                          </div>
                        </div>

                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>


   
                    	</CardBlock>


                    </Card>
                </div>
                { this.state.modal&&
	                <ModalTablas
	                    open={this.state.modal}
	                    toggle={this.toggle_modal}                  
	                    titulo={this.state.titulo}
	                    catalogo={this.state.tabla_modal}
	                    retorno={this.retorno}
	                    campo={this.state.campo_modal}
                      cliente_id={0}
	                />
	            }
            </div>
		)
	}
}

function mapStateToProps(state, ownProps) {
    return {
        factura : state.factura,
        notificciones:state.notificciones
    }
};
export default connect(mapStateToProps, actions)(InvoiceModuleForm)


// WEBPACK FOOTER //
// ./src/views/facturacion/invoiceModule/importacion.js